import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { LoggerService } from '@shared/services/logger.service';
import { SidebarService } from '@shared/services/sidebar.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContentComponent implements OnInit, OnDestroy {
  @ViewChild('header', { static: false })
  public headerEl: ElementRef;

  @Input() public title: string;
  @Input() public subtitle: string;
  @Input() public description: string;
  @Input() public iconClass: string;
  @Input() public counter: number;
  @Input() public contentClasses = String('pt-4');
  @Input() public colLeftSize = String('col-md-5');
  @Input() public colRightSize = String('col-md-7');
  @Input() public isSticky = Boolean(false);

  public isStickyTop: boolean;

  private readonly constructorName: string = String(this.constructor.name);

  private sidebarScrollSubscription: Subscription;

  constructor(
    private readonly _logger: LoggerService,
    private readonly _sidebar: SidebarService
  ) {}

  ngOnInit(): void {
    const url = 'Sidebar scroll';
    this.sidebarScrollSubscription = this._sidebar.scrollSidebarCalled$.subscribe(
      () => {
        // this._logger.info(this.constructorName, url, res);

        if (!!this.headerEl) {
          const rect = this.headerEl.nativeElement.getBoundingClientRect();
          const top = rect.top;

          this.isStickyTop = top === 0;
        }
      },
      (err: any) => this._logger.error(this.constructorName, url, err)
    );
  }

  ngOnDestroy(): void {
    this.sidebarScrollSubscription?.unsubscribe();
  }
}
